import { render, staticRenderFns } from "./Layout404.vue?vue&type=template&id=1fcf5b83&scoped=true&"
import script from "./Layout404.vue?vue&type=script&lang=js&"
export * from "./Layout404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf5b83",
  null
  
)

export default component.exports